<template>
    <div class="clickable-wrap">
      <add-content
        v-if="showAddContentModal"
        :coords="newCoords[selectedClickableIndex].coords"
        :content="newCoords[selectedClickableIndex].contentItems"
        :location="location"
        @soft-save-content="softSaveContentAndEmitParams"
        @close-modal="showAddContentModal=false"
      ></add-content>
      <select v-model="template">
        <option selected disabled :value="null">Select Template</option>
        <option v-for="template in templates" :key="template.tmp_id" :value="template">
          {{ template.tmp_name }}
        </option>
      </select>
      <div class="img-box-buttons" v-if="imageTemp">
        <label class="change-image" for="file">Change Image</label>
        <button class="cancel-button reset" @click="resetCoords">Reset clickable items</button>
        <button class="cancel-button reset" @click="clearCoords">Clear clickable items</button>
        <button class="cancel-button reset" v-if="template" @click="resetEdit">Remove Template</button>
      </div>
      <div :class="imageTemp? 'img-box-has-image' : 'img-box'">
        <input type="file" id="file" @change="getFile" ref="inputFile">
        <label for="file" v-if="!imageTemp">Click to upload an image...</label>
        <clickable-area-select
          v-else
          :image="imageTemp"
          :selected="newCoords"
          :changelink="true"
          @save="setNewCoords"
          @select="setClickableItemCoordsShowModal"
        ></clickable-area-select>
      </div>
    </div>
</template>

<script>
import api from '@/api';
import ClickableAreaSelect from '../booth-template/clickableAreaSelect';
import AddContent from './AddContent'
export default {
  components: {
    ClickableAreaSelect,
    AddContent
  },
  props: {
    image: String,
    location: Object,
    content: Array
  },
  data () {
    return {
      imageTemp: "",
      templates: [],
      template: null,
      oldCoords: [],
      newCoords: [],
      selectedClickableIndex: null,
      showAddContentModal: false,
      softSaveId: 1
    }
  },
  mounted () {
    this.getTemplates();
  },
  watch: {
    template: {
      handler () {
        this.checkForTemplateImage();
        if (this.template) {
          this.checkClickableForContent();
          this.$refs.inputFile.value = "";
          this.oldCoords = this.parseCoords();
          this.newCoords = this.parseCoords();
        }

        else if (this.content) {
          this.oldCoords = this.copyCoordsArray(this.content);
          this.newCoords = this.copyCoordsArray(this.content);
        }

        else {
          this.oldCoords = [];
          this.newCoords = [];
        }
      }
    },
    location : {
      handler () {
        this.resetEdit();
      }
    },
    image: {
      handler () {
        this.imageTemp = this.image;
      }
    },
    content: {
      handler () {
        this.oldCoords = this.content? this.copyCoordsArray(this.content) : [];
        this.newCoords = this.content? this.copyCoordsArray(this.content) : [];
      }
    }
  },
  methods: {
    async getTemplates () {
      try {
        const res = await api.getTemplates();
        this.templates = res.data.templates;
      } catch (error) {
        this.handleError(error);
      }
    },
    parseCoords () {
      let coordsArray = [];
      for (let i = 0; i < [JSON.parse(this.template.tmp_elems)][0].length; i++) {
        coordsArray.push([JSON.parse(this.template.tmp_elems)][0][i])
      }
      return coordsArray;
    },
    checkForTemplateImage () {
      if (this.template) {
        this.getTemplateImage()
      } else {
        this.imageTemp = this.image;
      }
    },
    async getTemplateImage () {
      this.startLoading()
      try {
        const res = await api.getTemplateImage({
          tmp_id: this.template.tmp_id
        });
        this.imageTemp = res.data;
        this.$emit('set-image', this.imageTemp);
      } catch (error) {
        this.handleError(error)
      }
      this.stopLoading();
    },
    getFile (e) {
      let tgt = e.target || window.event.srcElement,
      files = tgt.files;
      // FileReader support
      if (FileReader && files && files.length) {
        let fr = new FileReader();
        fr.onload = () => {
          this.imageTemp = fr.result;
          this.$emit('set-image', this.imageTemp);
        };
        fr.readAsDataURL(files[0]);
      }
    },
    setNewCoords (data) {
      this.handleAction(data);
      this.newCoords = this.copyCoordsArray(data.data);
    },
    handleAction (data) {
      let lastClickedContentObj;
      if (data.type === 'delete') {
        lastClickedContentObj = this.newCoords[data.index];
        if (lastClickedContentObj.contentItems) {
          if (lastClickedContentObj.contentItems.con_id) {
            this.emitDeleteContent(lastClickedContentObj)
          } else {
            this.$emit('check-soft-delete', lastClickedContentObj)
          }
        }
      } else if (data.type === 'resize' || data.type === 'move') {
        this.newCoords = this.copyCoordsArray(data.data);
        lastClickedContentObj = this.newCoords[data.index];
        if (lastClickedContentObj.contentItems) {
          if (lastClickedContentObj.contentItems.con_id || lastClickedContentObj.contentItems.softSaveId) {
            this.$emit('soft-save-content', lastClickedContentObj.contentItems);
          }
        }
      }
    },
    async emitDeleteContent (contentObj) {
      this.$emit('group-delete-content', {
        clm_id: contentObj.contentItems.clm_id,
        con_id: contentObj.contentItems.con_id,
      })
    },
    resetCoords () {
      if (this.template === null) this.$emit('revert-group-delete-content');
      this.$emit('delete-new-content-array');
      this.newCoords = this.copyCoordsArray(this.oldCoords);
    },
    copyCoordsArray (arr) {
      let copyArr = [];
      for (let i = 0; i < arr.length; i++) {
        let obj = {};
        obj.coords = {...arr[i].coords};
        if (arr[i].content) obj.content = arr[i].content;
        if (arr[i].contentItems) {
          obj.contentItems = {...arr[i].contentItems}
          obj.contentItems.top = obj.coords.top
          obj.contentItems.bottom = obj.coords.bottom
          obj.contentItems.left = obj.coords.left
          obj.contentItems.right = obj.coords.right
        }
        copyArr.push(obj);
      }
      return copyArr;
    },
    clearCoords () {
      this.checkClickableForContent();
      this.newCoords = [];
    },
    setClickableItemCoordsShowModal (obj) {
      this.selectedClickableIndex = obj.index;
      this.showAddContentModal = true;
    },
    resetEdit () {
      this.imageTemp = this.image;
      this.oldCoords = this.content? this.copyCoordsArray(this.content) : [];
      this.newCoords = this.content? this.copyCoordsArray(this.content) : [];
      this.template = null;
      this.$emit('revert-group-delete-content');
    },
    softSaveContentAndEmitParams (params) {
      if (params.con_id === undefined && params.softSaveId === undefined) {
        params.softSaveId = this.softSaveId++;
      }

      let newObj = {};  
      newObj.content = true;
      newObj.contentItems = params;
      newObj.coords = {...this.newCoords[this.selectedClickableIndex].coords};

      this.newCoords.splice(this.selectedClickableIndex, 1, newObj);

      this.$emit('soft-save-content', params);
    },
    checkClickableForContent () {
      for (let i = 0; i < this.newCoords.length; i++) {
        if (this.newCoords[i].content) {
          this.$emit('group-delete-content', {
            clm_id: this.newCoords[i].contentItems.clm_id,
            con_id: this.newCoords[i].contentItems.con_id,
          })
        }
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.overlay {
  border: none;
}
.clickable-wrap {
  position: relative;
  width: 100%;
  background: #FFF;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 20px 0;
}
.img-box {
  position: relative;
  min-height: 300px;
  min-width: 220px;
  width: 60%;
  border: 3px solid gray;
  border-radius: 10px;
}
.img-box-has-image {
  position: relative;
}
.img-box label {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
#file {
  display: none;
}
.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0;
}
button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  padding: 8px 23px;
  border-radius: 100px;
  font-size: 13px;
  margin: 5px 10px;
  outline: none;
}
.confirm-button {
  background-color: var(--button-color-blue);
  color: white;
}
.cancel-button {
  background: #e5e5e5;
}
.cancel-button:hover {
  background: #e5e5e5;
}
.img-box-buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.cancel-button.reset {
  border: 2px solid #e5e5e5; 
  background: #e5e5e5; 
  text-align: center;
}
.change-image {
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  padding: 8px 23px;
  border-radius: 100px;
  font-size: 13px;
  margin: 5px 10px;
  outline: none;
  border: 2px solid #e5e5e5; 
  background: #e5e5e5; 
}
</style>